import React, { Component } from "react";
import { Route, Router, Switch } from "react-router-dom";
import { connect } from "react-redux";
import ReactGA from "react-ga4";

import { history } from "./_helpers";
import { alertActions } from "./_actions";
import { PrivateRoute } from "./components/PrivateRoute";
import { withCookies } from "react-cookie";

import ScrollToTop from "./ScrollToTop";

import Dashboard from "./pages/Dashboard";
import EnergyServicesHome from "./pages/EnergyServicesHome";
import EnergyServicesUsage from "./pages/EnergyServicesUsage";
import EnergyServicesRankings from "./pages/EnergyServicesRankings";
import EnergyServicesAppliances from "./pages/EnergyServicesAppliances";
import EnergyServicesFeedback from "./pages/EnergyServicesFeedback";
import EnergyServicesAppliance from "./pages/EnergyServicesAppliance";

import AssistedLivingHome from "./pages/AssistedLivingHome";
import AssistedLivingActivities from "./pages/AssistedLivingActivities";
import AssistedLivingActivityDetail from "./pages/AssistedLivingActivityDetail";
import AssistedLivingActivityAlert from "./pages/AssistedLivingActivityAlert";
import AssistedLivingAppliances from "./pages/AssistedLivingAppliances";
import AssistedLivingFeedback from "./pages/AssistedLivingFeedback";
import AssistedLivingAlertsFeedback from "./pages/AssistedLivingAlertsFeedback";
import AssistedLivingAppliance from "./pages/AssistedLivingAppliance";
import AccountTariff from "./pages/AccountTariff";
import AccountTariffStandingCharge from "./pages/AccountTariffStandingCharge";
import AccountTariffEditTime from "./pages/AccountTariffEditTime";
import AccountTariffEditRates from "./pages/AccountTariffEditRates";
import AccountHome from "./pages/AccountHome";
import LoginPage from "./pages/LoginPage";
import ForgotPassword from "./pages/ForgotPassword";
import InitialSetup from "./pages/InitialSetup";
import Setup from "./pages/Setup";
import NewPasswordLoggedOut from "./pages/NewPasswordLoggedOut";
import AccountTariffInfo from "./pages/AccountTariffInfo";
import AccountHomeView from "./pages/AccountHomeView";
import AccountHolidayMode from "./pages/AccountHolidayMode";
import AccountAppliances from "./pages/AccountAppliances";
import AccountAppliance from "./pages/AccountAppliance";
import AccountDoNotDisturb from "./pages/AccountDoNotDisturb";
import AccountPassword from "./pages/AccountPassword";
import AccountInfoCare from "./pages/AccountInfoCare";
import AccountInfoCareAlerts from "./pages/AccountInfoCareAlerts";
import AccountInfoCareEmailReport from "./pages/AccountInfoCareEmailReport";
import { setUpAnalytics } from "./_services";

class Routes extends Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    history.listen((location, action) => {
      // clear alert on location change
      dispatch(alertActions.clear());
    });
  }

  componentWillMount() {
    ReactGA.initialize("G-PE15NMGPCM");
    ReactGA.set({ page: history.location.pathname + history.location.search });
    setUpAnalytics();
    ReactGA.send({ hitType: "pageview", page: history.location.pathname + history.location.search });
  }

  render() {
    return (
      <Router history={history} component={Dashboard}>
        <ScrollToTop>
          <Switch>
            <PrivateRoute exact path="/" component={Dashboard} />
            <PrivateRoute
              exact
              path="/my-home"
              component={EnergyServicesHome}
            />
            <PrivateRoute
              exact
              path="/my-home/usage"
              component={EnergyServicesUsage}
            />
            <PrivateRoute
              exact
              path="/my-home/rankings"
              component={EnergyServicesRankings}
            />
            <PrivateRoute
              exact
              path="/my-home/appliances"
              component={EnergyServicesAppliances}
            />
            <PrivateRoute
              exact
              path="/my-home/feedback"
              component={EnergyServicesFeedback}
            />

            <PrivateRoute
              exact
              path="/parents-home"
              component={AssistedLivingHome}
            />
            <PrivateRoute
              exact
              path="/parents-home/activities"
              component={AssistedLivingActivities}
            />
            <PrivateRoute
              exact
              path="/parents-home/activities/:activity_id"
              component={AssistedLivingActivityDetail}
            />
            <PrivateRoute
              exact
              path="/parents-home/activities/alert/:activity_id"
              component={AssistedLivingActivityAlert}
            />
            <PrivateRoute
              exact
              path="/parents-home/appliances"
              component={AssistedLivingAppliances}
            />
            <PrivateRoute
              exact
              path="/parents-home/feedback"
              component={AssistedLivingFeedback}
            />
            <PrivateRoute
              exact
              path="/parents-home/alert-feedback/:alert_id"
              component={AssistedLivingAlertsFeedback}
            />
            <PrivateRoute
              exact
              path="/my-home/appliance/:appliance_id"
              component={EnergyServicesAppliance}
            />
            <PrivateRoute
              exact
              path="/parents-home/appliance/:appliance_id"
              component={AssistedLivingAppliance}
            />
            {/* <PrivateRoute exact path="/account" component={Account} /> */}
            <PrivateRoute exact path="/account" component={AccountHome} />
            <PrivateRoute
              exact
              path="/account/do-not-disturb"
              component={AccountDoNotDisturb}
            />
            <PrivateRoute
              exact
              path="/account/password"
              component={AccountPassword}
            />

            <PrivateRoute
              exact
              path="/account/homeview"
              component={AccountHomeView}
            />
            <PrivateRoute
              exact
              path="/account/:level/holiday-mode"
              component={AccountHolidayMode}
            />
            <PrivateRoute
              exact
              path="/account/:level/tariff"
              component={AccountTariff}
            />
            <PrivateRoute
              exact
              path="/account/:level/tariff/standing-charge"
              component={AccountTariffStandingCharge}
            />
            <PrivateRoute
              exact
              path="/account/:level/tariff/edit-time/:time/:rate"
              component={AccountTariffEditTime}
            />
            <PrivateRoute
              exact
              path="/account/:level/tariff/edit-rates/:time/:rate"
              component={AccountTariffEditRates}
            />
            <PrivateRoute
              exact
              path="/account/:level/appliances"
              component={AccountAppliances}
            />
            <PrivateRoute
              exact
              path="/account/:level/appliance/:appliance_id"
              component={AccountAppliance}
            />

            <PrivateRoute
              exact
              path="/account/infocare"
              component={AccountInfoCare}
            />
            <PrivateRoute
              exact
              path="/account/tariff/info"
              component={AccountTariffInfo}
            />
            <PrivateRoute
              exact
              path="/account/infocare/alerts"
              component={AccountInfoCareAlerts}
            />
            <PrivateRoute
              exact
              path="/account/infocare/email-report"
              component={AccountInfoCareEmailReport}
            />

            <PrivateRoute
              exact
              path="/initial-setup"
              component={InitialSetup}
            />
            <PrivateRoute exact path="/setup" component={Setup} />

            <Route path="/login" component={LoginPage} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route
              path="/accounts/change_password/"
              component={NewPasswordLoggedOut}
            />
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

export default withCookies(connect(mapStateToProps)(Routes));
// export { connectedApp as Routes };
